// eslint-disable-next-line @nx/enforce-module-boundaries
import { BusinessModel, MemberRegister, OrderType, PaymentType, ShopOption } from '@us/web/shared/data-access';
import { DEFAULT_LANGUAGE } from './const.util';
import { getArray, getBoolean, getObject, getStringValue } from './helper.util';

export const convertShopOption = (payload: any): ShopOption => {
    const result: any = {};
    for (const key in payload) {
        switch (key) {
            case 'business_model':
                result[key] = getArray<BusinessModel>(payload.business_model, Number);
                break;
            case 'buy_without_login':
            case 'do_not_display_provincial_city_district_select_box':
            case 'only_allowed_to_use_products_in_the_price_list':
            case 'account_verification':
            case 'allow_login_via_sms':
            case 'allow_login_via_zalo_oa':
            case 'allow_login_via_facebook':
            case 'turn_on_enter_number_guest':
            case 'merge_order_qr':
            case 'category_scroll_list':
            case 'display_information_after_ordering':
            case 'turn_off_address':
            case 'turn_on_contact_to_right':
            case 'enable_show_menu':
            case 'display_weekly_menu':
            case 'force_require_login':
            case 'require_note':
                result[key] = getBoolean(payload[key], false);
                break;
            case 'turn_on_the_store_chain_link_feature':
            case 'turn_on_the_store_link_feature':
                result[key] = getBoolean(payload[key], true);
                break;
            case 'allow_online_booking':
            case 'template':
            case 'setting_print_external':
            case 'website_address_provider':
                result[key] = Number(payload[key]);
                break;
            case 'payment_methods':
                result[key] = getArray<PaymentType>(payload[key]);
                break;
            case 'order_types':
                result[key] = getArray<OrderType>(payload[key], Number);
                break;
            case 'member_register':
                result[key] = getObject(payload[key]) as MemberRegister;
                break;
            case 'allow_online_ordering':
            case 'default_food_menus_mode':
            case 'top_banner_content':
            case 'footer_html':
            case 'payment_notes':
            case 'website_address':
            case 'phone':
            case 'zalo':
            case 'facebook_messenger':
            case 'facebook_fanpage':
            case 'bank_transfer_information':
            case 'facebook_app_id':
            case 'turn_on_the_store_link_time':
            case 'zalo_chat_widget':
            case 'require_note_placeholder':
                result[key] = getStringValue(payload[key]);
                break;
            case 'default_language':
                result[key] = getStringValue(payload[key], DEFAULT_LANGUAGE);
                break;
            case 'colors':
                result[key] = getObject(payload[key]);
                break;
            default:
                result[key] = payload[key];
                break;
        }
    }

    return result as ShopOption;
};
